var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { memo } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Text } from 'pcln-design-system';
var IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CircleSmall__IconWrapper",
  componentId: "sc-1zgar8-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
function BaseComponent(_a) {
  var title = _a.title,
    titleId = _a.titleId,
    props = __rest(_a, ["title", "titleId"]);
  var themeContext = React.useContext(ThemeContext);
  var themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", __assign({
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    viewBox: '0 0 168 168',
    focusable: false,
    "aria-hidden": true,
    role: 'img',
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("circle", {
    cx: 1100,
    cy: 359,
    r: 84,
    fill: '#EDFF7A',
    fillRule: 'evenodd',
    transform: 'translate(-1016 -275)'
  }));
}
var CircleSmall = function (props) {
  return React.createElement(IconWrapper, {
    fontSize: props.size,
    lineHeight: props.size,
    verticalAlign: 'middle',
    className: props.className
  }, React.createElement(BaseComponent, null));
};
/** @public */
var Memo = memo(CircleSmall);
export default Memo;
var templateObject_1;